(() => {
  const surface = document.querySelector('[data-mobile-search-surface]');
  if (!surface) return;

  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const form = surface.querySelector('[data-mobile-search-form]');
  const input = surface.querySelector('[data-mobile-search-input]');
  const results = surface.querySelector('[data-mobile-search-results]');
  const discovery = surface.querySelector('[data-mobile-search-discovery]');
  const closeButton = surface.querySelector('[data-mobile-search-close]');
  const clearButton = surface.querySelector('[data-predictive-search-clear]');
  const loading = surface.querySelector('[data-mobile-search-loading]');

  if (!form || !input || !results || !closeButton) return;

  let sourceInput = null;
  let suppressEntryFocus = false;

  const entryFor = (target) => target instanceof Element
    ? target.closest('[data-mobile-search-entry]')
    : null;

  const syncDiscovery = () => {
    if (!discovery) return;
    discovery.hidden = input.value.trim().length > 0;
  };

  const open = (entry) => {
    if (!mobileQuery.matches || surface.hidden === false) return;

    sourceInput = entry || null;
    delete surface.dataset.navigating;
    surface.removeAttribute('aria-busy');
    if (loading) loading.hidden = true;
    surface.hidden = false;
    document.body.classList.add('is-mobile-search-open');
    input.value = entry?.value || '';
    input.dataset.hasValue = input.value.length > 0 ? 'true' : 'false';
    syncDiscovery();
    input.dispatchEvent(new Event('input', { bubbles: true }));
    window.requestAnimationFrame(() => input.focus({ preventScroll: true }));
  };

  const close = () => {
    if (surface.hidden) return;

    surface.hidden = true;
    delete surface.dataset.navigating;
    surface.removeAttribute('aria-busy');
    if (loading) loading.hidden = true;
    document.body.classList.remove('is-mobile-search-open');
    results.hidden = true;
    results.setAttribute('aria-busy', 'false');
    input.setAttribute('aria-expanded', 'false');
    input.value = '';
    input.dataset.hasValue = 'false';
    discovery?.removeAttribute('hidden');

    if (sourceInput?.isConnected) {
      suppressEntryFocus = true;
      sourceInput.focus({ preventScroll: true });
      window.requestAnimationFrame(() => {
        suppressEntryFocus = false;
      });
    }
    sourceInput = null;
  };

  document.addEventListener('pointerdown', (event) => {
    const entry = entryFor(event.target);
    if (!entry || surface.contains(entry) || !mobileQuery.matches) return;
    event.preventDefault();
    open(entry);
  }, true);

  document.addEventListener('focusin', (event) => {
    const entry = entryFor(event.target);
    if (!entry || surface.contains(entry) || suppressEntryFocus || !mobileQuery.matches) return;
    open(entry);
  });

  document.addEventListener('click', (event) => {
    const entry = entryFor(event.target);
    if (!entry || surface.contains(entry) || !mobileQuery.matches) return;
    event.preventDefault();
    open(entry);
  });

  input.addEventListener('input', syncDiscovery);
  clearButton?.addEventListener('click', () => window.requestAnimationFrame(syncDiscovery));
  closeButton.addEventListener('click', close);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !surface.hidden) close();
  });

  const leaveSurface = () => {
    surface.hidden = true;
    document.body.classList.remove('is-mobile-search-open');
  };

  const showLoading = () => {
    surface.dataset.navigating = 'true';
    surface.setAttribute('aria-busy', 'true');
    results.hidden = true;
    if (discovery) discovery.hidden = true;
    if (loading) loading.hidden = false;
    input.blur();
  };

  form.addEventListener('submit', showLoading);
  surface.addEventListener('click', (event) => {
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    const url = new URL(anchor.href, window.location.href);
    const localeRoot = window.Shopify?.routes?.root || '/';
    const searchPath = `${localeRoot.replace(/\/$/, '')}/search`;
    if (url.pathname === searchPath || url.pathname === '/search') {
      showLoading();
    } else {
      leaveSurface();
    }
  });

  mobileQuery.addEventListener?.('change', (event) => {
    if (!event.matches) close();
  });

  window.addEventListener('pageshow', () => {
    if (!surface.hidden) close();
  });
})();
